<template>
  <div v-show="isLoaded" class="mBannerRose-container" v-observe-visibility="startAnimate">
    <img class="mBannerRose-image" :src="banner" alt="BannerRose">
    <img class="mBannerRose-image-desktop" :src="banner_desktop" alt="BannerRose">
    <div class="mBannerRose-title-container">
        <h1 class="mBannerRose-title" :class="{animate: animate, onlySafari: isSafari}">
            StrongBow
        </h1>
        <h2 class="mBannerRose-subtitle" :class="{animate: animate}">
            Rosé Apple
        </h2>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/rose-apple/rose_apple.png';
import banner_desktop from '@/assets/rose-apple/banner_desktop.png';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
    name: "BannerRose",
    data() {
        return {
            banner,
            banner_desktop,
            animate: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        }
    },
    components: {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RoseApple/BannerRose.scss";
</style>